<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  ARIForm(
    v-show="!isSubmitting",
    :data="ariData",
    :current-ari-id="ariId",
    :is-edit="true",
    :on-save-draft="saveDraft",
    @submit="update"
  )
</template>

<script>
import ARIForm from '../shared/ARIForm.vue'
import useInherentRiskEdit from './useInherentRiskEdit'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { onMounted } from '@vue/composition-api'

export default {
  name: 'InherentRiskEdit',
  components: {
    ARIForm,
    Loading,
  },
  setup() {
    const { update, saveDraft, ariData, ariId, isSubmitting, show } = useInherentRiskEdit()

    onMounted(show)

    return {
      update,
      saveDraft,
      ariData,
      ariId,
      isSubmitting,
    }
  },
}
</script>
